/** @jsxImportSource @emotion/react */

const Spinner = () => {
  return (
    <div
      css={{
        zIndex: 50,
        background: 'rgba(255,255,255, 0.6)',
        width: '100%',
        height: '100%',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        position: 'absolute',
      }}
    >
      <div
        css={{
          border: '2px solid #D3D3D3',
          borderTop: '2px solid #3498db',
          borderRadius: '50%',
          width: '40px',
          height: '40px',
          animation: 'spin 0.8s infinite',
          animationTimingFunction: 'cubic-bezier(0.1, 0.5, 0.6, 0.1)',
        }}
      />
    </div>
  );
};

export default Spinner;
